import drawingToolReducer from './drawingToolReducer'

let reducers = {
  drawingTool: drawingToolReducer,
}

export default reducers